import { Injectable } from '@angular/core';
import { ApiDataService } from '../shared/services/api.data.service';
import { Observable, shareReplay } from 'rxjs';
import { AssetFault } from '../models/assetFault';
import { AssetFaultDisplay } from '../models/assetFaultDisplay';

@Injectable({
  providedIn: 'root'
})
export class AssetFaultService {

  constructor(private api: ApiDataService) {

  }

  private $faultStates: Observable<{ [key: number]: string }>;

  getAssetFaultState(vin: string): Observable<AssetFault[]> {
    const url = this.api.buildUrl(`assetFault/${vin}`);
    return this.api.get(url);
  }

  getFaultDetail(vin: string, start: Date, end: Date, fault: AssetFaultDisplay): Observable<AssetFault[]> {
    const url = this.api.buildUrl(`assetFault/${vin}`);
    return this.api.post(url, {start, end, protocol: fault.protocol, faultCode: fault.faultCode, controller: fault.controller, failureMode: fault.failureMode});
  }

  // Omitting protocol returns every fault in the window, all protocols, against
  // a date range. getAssetFaultState returns the current record instead, which
  // keeps inactive rows until the writer prunes them.
  getFaultsInRange(vin: string, start: Date, end: Date): Observable<AssetFault[]> {
    const url = this.api.buildUrl(`assetFault/${vin}`);
    return this.api.post(url, {start, end});
  }

  getFaultStates(): Observable<{ [key: number]: string }> {
    if(this.$faultStates === undefined) {
      const url = this.api.buildUrl(`assetFault/faultStates`);
      this.$faultStates = this.api.get(url).pipe(shareReplay());
    }
    return this.$faultStates;
  }
}
